import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";

import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';
import DesignUnderLine2 from "../../components/ExcerciseTypes/Design/DesignUnderLine2";
const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay : true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page2/Key/E1answerKey.png",
    
    titleQuestion: [
      {
        num: "",
        title: "<img src='/img/FriendsPlus/Page2/a.jpg' style='height:15mm' /> Tìm và nói nhanh 5 điểm khác nhau giữa hai tranh. ",
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
   
    component: DesignUnderLine2,
    totalInput: 5,
	isHiddenCheck:true,
	Recorder:true,
    titleImage: "",
    isAllowSubmit: false,
    questionImage: [
      // Row
      [
		{ url: 	"img/FriendsPlus/Page2/E1/1.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/2.jpg",input:1 },
		{ url: 	"img/FriendsPlus/Page2/E1/3.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/4.jpg",input:1 },
		{ url: 	"img/FriendsPlus/Page2/E1/5.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/6.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/7.jpg",input:1 },
		{ url: 	"img/FriendsPlus/Page2/E1/8.jpg",input:2,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/9.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/10.jpg",input:1 },
		{ url: 	"img/FriendsPlus/Page2/E1/11.jpg",input:2,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/12.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/13.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/14.jpg",input:3 },
		{ url: 	"img/FriendsPlus/Page2/E1/15.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/16.jpg",input:4 },
		{ url: 	"img/FriendsPlus/Page2/E1/17.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/18.jpg",input:3 },
		{ url: 	"img/FriendsPlus/Page2/E1/19.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/20.jpg",input:4  },
		{ url: 	"img/FriendsPlus/Page2/E1/21.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/22.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/23.jpg",input:3 },
		{ url: 	"img/FriendsPlus/Page2/E1/24.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/25.jpg",input:4 },
		{ url: 	"img/FriendsPlus/Page2/E1/26.jpg",input:5 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/27.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/28.jpg",input:3 },
		{ url: 	"img/FriendsPlus/Page2/E1/29.jpg"  },
		{ url: 	"img/FriendsPlus/Page2/E1/30.jpg",input:4 },
		{ url: 	"img/FriendsPlus/Page2/E1/31.jpg",input:5 ,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/32.jpg"  },],[
		{ url: 	"img/FriendsPlus/Page2/E1/33.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/34.jpg",input:3 },
		{ url: 	"img/FriendsPlus/Page2/E1/35.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/36.jpg",input:5 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/37.jpg",input:5 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/38.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/39.jpg",input:3 },
		{ url: 	"img/FriendsPlus/Page2/E1/40.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/41.jpg",input:5 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/42.jpg",input:5 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/43.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/44.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/45.jpg",input:6 },
		{ url: 	"img/FriendsPlus/Page2/E1/46.jpg",input:7,isCorrect:true, },
		{ url: 	"img/FriendsPlus/Page2/E1/47.jpg",input:5 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/48.jpg",input:8 ,isCorrect:true},
		{ url: 	"img/FriendsPlus/Page2/E1/49.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/50.jpg",input:6  },
		{ url: 	"img/FriendsPlus/Page2/E1/51.jpg",input:7,isCorrect:true,  },
		{ url: 	"img/FriendsPlus/Page2/E1/52.jpg",input:5 ,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/53.jpg",input:8 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/54.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/55.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/56.jpg",input:6  },
		{ url: 	"img/FriendsPlus/Page2/E1/57.jpg",input:9  },
		{ url: 	"img/FriendsPlus/Page2/E1/58.jpg",input:5 ,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/59.jpg",input:8 ,isCorrect:true },
		{ url: 	"img/FriendsPlus/Page2/E1/60.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/61.jpg",input:10 },
		{ url: 	"img/FriendsPlus/Page2/E1/62.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/63.jpg",input:6  },
		{ url: 	"img/FriendsPlus/Page2/E1/64.jpg",input:9   },
		{ url: 	"img/FriendsPlus/Page2/E1/65.jpg",input:5 ,isCorrect:true   },
		{ url: 	"img/FriendsPlus/Page2/E1/66.jpg",input:8 ,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/67.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/68.jpg",input:10  },
		{ url: 	"img/FriendsPlus/Page2/E1/69.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/70.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/71.jpg",input:9 },
		{ url: 	"img/FriendsPlus/Page2/E1/72.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/73.jpg",input:10 },
		{ url: 	"img/FriendsPlus/Page2/E1/74.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/75.jpg",input:9  },
		{ url: 	"img/FriendsPlus/Page2/E1/76.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/77.jpg",input:10  },
		{ url: 	"img/FriendsPlus/Page2/E1/78.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/79.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/80.jpg",input:11,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/81.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/82.jpg",input:10 },
		{ url: 	"img/FriendsPlus/Page2/E1/83.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/84.jpg",input:11,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/85.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/86.jpg",input:10 },
		{ url: 	"img/FriendsPlus/Page2/E1/87.jpg" },],[
		{ url: 	"img/FriendsPlus/Page2/E1/88.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/89.jpg",input:11,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/90.jpg" },
		{ url: 	"img/FriendsPlus/Page2/E1/91.jpg",input:11,isCorrect:true  },
		{ url: 	"img/FriendsPlus/Page2/E1/92.jpg" },
		
    ]
      
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay : true,
    video: "",
    // recorder: true,
    // exerciseKey: "/img/FriendsPlus/Page4/Key/E1answerKey.jpg",
    component: T6,
    isHiddenCheck:true,
	hideBtnFooter:true,
    stylesTextInput: { },
    inputSize:500,
    titleQuestion: [
      {
        num: "",
        title: `
			<img src='/img/FriendsPlus/Page2/E2/1.jpg' style='height:15mm;margin-right:50px' /> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
   
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
			<div style='width:20cm'>
				&emsp;Khánh và Long là anh em sinh đôi. Hai anh em giống nhau như đúc. Hồi
				nhỏ thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần
				dần, Long không còn thấy thú vị nữa. Mỗi khi bị gọi nhầm tên,
				Long lại muốn kêu lên: "Tôi là Long, tôi chẳng giống ai hết.".
				<br>
				&emsp;Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc. 
				Còn anh cậu chẳng bận tâm đến chuyện đó.
				<br>
				&emsp;Một lần, hai anh em tham gia hội thao của trường. Long vô cùng lo lắng. 
				Hai anh em mặc đồng phục và đội mũ giống hệt nhau, bạn bè lại cổ vũ nhầm mất thôi. 
				Nhưng khi thi đấu, Long nhận ra các bạn không nhầm lẫn chút nào. Các bạn cổ vũ Long 
				đuổi theo Khánh khi Khánh dẫn đầu đường chạy. Các bạn cuống quýt gọi Khánh thay thế khi thấy 
				Long nhăn nhó vì đau trong trận kéo co... Hội thao kết thúc trong nỗi ngạc nhiên ngập tràn của Long.
				<br>
				&emsp;Trên đường về, Long hỏi Vân: <br>
				&emsp;-	Sao hôm nay không ai hỏi nhầm chúng tớ nhỉ?
				<br>
				&emsp;Vân khúc khích<br>
				&emsp;-	Vì Khánh hay cười, còn cậu lúc nào cũng nghiêm túc.<br>
				&emsp;Vĩng chen vào: <br>
				&emsp;- Cậu thì chậm rãi, Khánh thì nhanh nhẩu, sao nhầm được. <br>
				&emsp;Nghe Long thắc mắc về những lần bạn bè nhầm lẫn, các bạn cùng cười:<br>
				&emsp;- Nhìn xa thì tưởng giống nhau, chứ nhìn gần thì mỗi cậu một vẻ mà. Có lúc bọn tới còn giả vờ nhầm để trêu các cậu đấy. <br>
				&emsp;Anh Khánh lúc đó mới lên tiếng: <br>
				&emsp;- Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.<br>
				&emsp;Tiếng cười rộn rã làm tan biến mọi thắc mắc của Long. Cậu cũng phá lên cười. Cậu hiểu ra: Cậu vẫn là cậu, anh Khánh vẫn là anh Khánh, hai anh em chỉ giống nhau bề ngoài thôi.

				<div style='text-align: end'>(Châu Khuê)</div>
			</div>
       
          
        `,
        answer: [],
      },
    ],
    
  },
  
};

export default json;
